import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StratifyDocument } from "@stratify/shared";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { selectPropertyById } from "../../../properties/store/propertiesSelectors";

interface BreadcrumbNavProps {
  document: StratifyDocument;
  propertyId?: string;
}

export const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({
  document,
  propertyId,
}) => {
  const navigate = useNavigate();
  const property = useSelector((state: RootState) =>
    propertyId ? selectPropertyById(state, propertyId) : null
  );

  return (
    <Breadcrumbs sx={{ mb: 3 }}>
      {property && (
        <Link
          color="inherit"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/properties");
          }}
          sx={{ cursor: "pointer" }}
        >
          Properties
        </Link>
      )}
      {property && (
        <Link
          color="inherit"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/properties/${propertyId}`);
          }}
          sx={{ cursor: "pointer" }}
        >
          {property.address || property.strataPlanNumber}
        </Link>
      )}

      {!property && (
        <Link
          color="inherit"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/documents");
          }}
          sx={{ cursor: "pointer" }}
        >
          Documents
        </Link>
      )}
      <Typography color="text.primary">{document.filename}</Typography>
    </Breadcrumbs>
  );
};
